import { useTLang } from 'intl/intl';

export function useSubstitutionFlowDeleteItemBtnLang() {
  return {
    deleteProductLabel: useTLang({ id: 'substitutionFlow.042' }),
    deleteToppingLabel: useTLang({ id: 'substitutionFlow.047' }),
  };
}
